/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-14
 */

import React from 'react';
import { connect } from 'dva';
import { modelUtils } from '@/utils';

import { utils_tool, component_tool, framework_tool } from '@/tool';

let { Session } = utils_tool;
import { ChapterPreview, ExamChapter } from '../../../online'

import classnames from 'classnames';
import { Form, Spin } from 'antd'
const { WizButton, WizRow, WizCol, WizNotice, WizIcon, WizTypography, WizSelect, WizInput, WizModalForm, WizModal, WizAlert,
    WizTable, WizDataTable, WizDropdown, WizMenu, WizInputNumber, WizPagination, WizCustomSteps } = component_tool;
import { WizTableForm } from '../../../common'

import {
    staticwizTabelColumns,
    dynamicWizTableColumns,
    dynamicWizModalFormColumns,
} from './columns';

import './index.less'

const { Text } = WizTypography;
let WizForm = Form
let Item = Form.Item
const WizItem = WizMenu.Item
const { WizContainer } = framework_tool;
let Option = WizSelect.Option


class ChapterLook extends WizContainer {
    componentName = 'chapterLook';

    constructor(props) {
        super(props);
        this.state = {
            record: {}, //当前选中章节的这条记录
            id: props.id,
            copyExam: false,
            copyExamId: props.id,
            currentIndex: 0, //当前选中章节项的索引
            data: props['data'] || [], //所有的章节信息
            questionTabelForm: [],//选择题目tabel中的数据
            categoryTabelForm: [],//分类tabel中的数据
            dynamicWizTableInfo: [],
            questionKey: new Date().getTime(),
            questionModalFormVisible: false,//题目是否显示状态
            categoryModalFormVisible: false,//题目分类是否显示状态
            previewPModalFormVisible: false,//题目查看显示状态
            previewnKey: new Date().getTime(),
            text: null,//章节提示信息

        };
        this.categoryType = 'create'//分类类型初始未新增点击修改时
        this.type = 'static'//分类类型初始未新增点击修改时
        this.count = 0//符合题型的题目数
    }

    _componentDidMount() {
        const { id, copyExam, copyExamId } = this.state

        const arr = [];
        this.setState({
            data: arr
        });
    }
    //START propsAndStateOnChange
    propsAndStateOnChange = {
        questionTabelForm: this._questionTabelForm.bind(this),
        categoryTabelForm: this._categoryTabelForm.bind(this),
        data: this._data.bind(this),
    };
    _data(nextProps, nextState) {
        if (nextState.currentIndex !== -1) {
            nextState.data = nextProps.data
        }
        this.setState({
            data: nextProps['data'],
            record: nextProps['data'][0],
            questionTabelForm: nextProps['data'][0].questionTabelForm ? nextProps['data'][0].questionTabelForm : [],
            categoryTabelForm: nextProps['data'][0].categoryTabelForm ? nextProps['data'][0].categoryTabelForm : [],
            currentIndex: 0,
            text: null,
        });
        return false;
    }
    _questionTabelForm(nextProps, nextState) {
        if (nextState.currentIndex !== -1) {
            nextState.record['questionTabelForm'] = nextState.questionTabelForm
            nextState.data[nextState.currentIndex]['questionTabelForm'] = nextState.questionTabelForm
        }
        return true;
    }
    _categoryTabelForm(nextProps, nextState) {
        if (nextState.currentIndex !== -1) {
            nextState.record['categoryTabelForm'] = nextState.categoryTabelForm
            nextState.data[nextState.currentIndex]['categoryTabelForm'] = nextState.categoryTabelForm
        }
        return true;
    }
    //END propsAndStateOnChange

    //章节按钮校验
    check = record => {
        if (!record.order) {
            WizNotice.warn('请选择一项');
            return false;
        }
        return true;
    };

    //章节部分点击事件
    handleClick = (val, index) => {
        this.setState({
            record: val,
            questionTabelForm: val.questionTabelForm ? val.questionTabelForm : [],
            categoryTabelForm: val.categoryTabelForm ? val.categoryTabelForm : [],
            currentIndex: index,
            text: null,
        });
    };

    //章节列表
    _renderChapters(record, data = [],currentIndex) {
        if (data.length) {
            return data.map((val, index) => {
                let className = classnames(
                    'chapter-item',
                    index === currentIndex ? 'active' : ''
                )
                return (
                    <li key={currentIndex + '@' + index} className={className} onClick={() => this.handleClick(val, index)}>
                        <span className='badge'>{this._getValue('chapter', val.type)}</span>
                        {val.title}
                    </li>
                )
            })
        }
        return null
    }

    handleMenuClick(e) {
        const { data } = this.state
        let addData = Object.assign([], data)
        let length = data.length
        if (e.key === 'static') {
            //新增key固定为0
            addData.push({
                key: 0,
                type: 1,
                title: '',
                order: length
            });
        } else if (e.key === 'dynamic') {
            addData.push({
                key: 0,
                type: 2,
                title: '',
                order: length
            });
        } else if (e.key === 'multiple') {
            addData.push({
                key: 0,
                type: 0,
                title: '',
                order: length
            });
        }
        this.setState({
            data: addData
        });
    }

    //考试章节左侧栏
    _renderChapterMenu() {
        const menu = (
            <WizMenu onClick={this.handleMenuClick.bind(this)}>
                <WizItem key="static">
                    固定章节
        </WizItem>
                <WizItem key="dynamic">
                    随机章节
        </WizItem>
                <WizItem key="multiple">
                    综合章节
        </WizItem>
            </WizMenu>
        );
        const { record, data,currentIndex } = this.state;
        return (
            <div className='chapter'>
                <div className='chapter-title'>{'考试章节'}</div>
                <div className='chapter-body'>
                    <ul className='chapter-items'>
                        {this._renderChapters(record, data,currentIndex)}
                    </ul>
                </div>
            </div>
        )
    }

    //题目类型对应
    _getValue(type, key) {
        const values = {
            type: {
                0: '单选题',
                1: '多选题',
                2: '判断题',
                3: '填空题',
                4: '主观题',
                6: '文件上传题',
                7: '排序题',
            },
            difficulty: {
                0: '低',
                1: '中',
                2: '高',
            },
            chapter: {
                0: '综合',
                1: '固定',
                2: '随机',
            }
        }
        return values[type][key]
    }



    //综合章节form
    _renderMultipleTable() {
        const { record, currentIndex, data } = this.state;
        let form
        if (record['tabelType'] === 'static') {

            form = this._questionModalForm()
        } else if (record['tabelType'] === 'dynamic') {
            form = this._categoryModalForm()
        }
        let copyRecord = Object.assign({}, record)
        return (
            <>
                <WizButton.Group>
                    <WizButton type={copyRecord['tabelType'] === 'static' ? 'primary' : 'default'} onClick={() => {
                        copyRecord['tabelType'] = 'static'
                        data[currentIndex] = copyRecord
                        this.setState({ record: copyRecord })
                    }}>
                        固定题目
            </WizButton>
                    <WizButton type={copyRecord['tabelType'] === 'dynamic' ? 'primary' : 'default'}
                        onClick={() => {
                            copyRecord['tabelType'] = 'dynamic'
                            data[currentIndex] = copyRecord
                            this.setState({ record: copyRecord })
                        }}>
                        随机抽题
            </WizButton>
                </WizButton.Group>
                {form}
            </>
        )

    }

    _titleModalForm() {

        const { questionTabelForm, categoryTabelForm, record, text } = this.state;
        let sum = 0
        let sumQuestion = 0
        let initialValue = []
        let style = null
        initialValue = questionTabelForm.map(p => p.id)
        if (record.score || record.score==0) {
            sum = questionTabelForm.length * record.score
            sumQuestion = questionTabelForm.length
            if (categoryTabelForm) {
                categoryTabelForm.forEach(form => {
                    sumQuestion = sumQuestion + form.total * 1
                    sum = sum + form.total * record.score
                })
            }
        }
        return (
            <>
                <div className="form-control">
                    <div className="form-title"><Text strong >名称  </Text></div>
                    <div style={{ width: 180 }} className="form-input">
                        <WizInput
                            key={record.order}
                            defaultValue={record.title}
                            disabled={true}
                            placeholder='请输入章节名称' />
                    </div>
                </div>
                <div className="form-control">
                    <div className="form-title"> <Text strong>每题分数  </Text></div>
                    <div className="form-input"><WizInputNumber
                        style={{ 'width': '180px' }}
                        max={99.5}
                        key={record.order}
                        defaultValue={record.score}
                        disabled={true}
                        placeholder='请输入分数' /></div>
                </div>
              <div className="form-control">
                <div className="form-title"><Text strong>章节描述 </Text></div>
                <div className="form-input"><div dangerouslySetInnerHTML={{__html: record?.description}}/></div>
              </div>


              <div style={{ marginTop: 15 }}> <Text style={style} strong>{'共' + sumQuestion + '题,总分' + sum + '分'}  </Text></div>
            </>)
    }
    _renderStaticTable() {

        const { questionModalFormVisible, previewPModalFormVisible, questionTabelForm, categoryTabelForm, record, questionKey, text, previewnKey } = this.state;
        let sum = 0
        let initialValue = []
        let style = null
        initialValue = questionTabelForm.map(p => p.id)
        if (record.score) {
            sum = questionTabelForm.length * record.score
        }
        return (
            <>
                <div>
                    <WizButton
                        onClick={() => { this.setState({ previewPModalFormVisible: true, previewnKey: new Date().getTime() }) }}
                        style={{ marginTop: 15, marginBottom: 15 }}
                    >
                        查看章节题目
          </WizButton>
                </div>
                <div>
                    <WizTable columns={staticwizTabelColumns(this)} key={record['order']} dataSource={questionTabelForm} />
                    <WizModal width={900} title="题目查看" visible={previewPModalFormVisible}
                        footer={<WizButton onClick={e => this.setState({ previewPModalFormVisible: false })}>关 闭</WizButton>}
                        onCancel={() => {
                            this.setState({ previewPModalFormVisible: false })
                        }}>
                        <ChapterPreview key={previewnKey} chapterCategoryInfoList={categoryTabelForm} questionIds={questionTabelForm} title={record['title']} score={record['score']} description={record['description']} />
                    </WizModal>
                </div>
            </>)
    }
    _renderDynamicTable() {

        const { categoryModalFormVisible, record, categoryTabelForm, questionTabelForm, dynamicWizTableInfo, text, previewPModalFormVisible, previewnKey } = this.state;
        return (
            <>

                <div>
                    <WizButton
                        onClick={() => { this.setState({ previewPModalFormVisible: true, previewnKey: new Date().getTime() }) }}
                        style={{ marginTop: 15, marginBottom: 15 }}
                    >
                        查看章节题目
                </WizButton>
                </div>
                <WizModal width={900} title="题目查看" visible={previewPModalFormVisible}
                    footer={<WizButton onClick={e => this.setState({ previewPModalFormVisible: false })}>关 闭</WizButton>}
                    onCancel={() => {
                        this.setState({ previewPModalFormVisible: false })
                    }}>
                    <ChapterPreview key={previewnKey} chapterCategoryInfoList={categoryTabelForm} questionIds={questionTabelForm} title={record['title']} score={record['score']} description={record['description']}  />
                </WizModal>
                <div>
                    <WizTable columns={dynamicWizTableColumns(this)} key={record['order']} dataSource={categoryTabelForm} />
                </div>
            </>)
    }
    //随机抽题form
    _categoryModalForm() {
        const { record, categoryTabelForm } = this.state;
        let count = 0
        let score = 0
        if (categoryTabelForm && categoryTabelForm instanceof Array && categoryTabelForm.length > 0) {
            count = categoryTabelForm.map(p => p['total']).reduce((prev, next) => prev + next)
            if (record['score']) {
                score = record['score'] * count
            }
        }
        let message = `共${count}题,共${score}分`
        return (
            <>

                <WizAlert message={message} type="info" showIcon />
                {this._renderDynamicTable()}
            </>
        )
    }
    //固定章节form
    _questionModalForm() {

        const { record, questionTabelForm } = this.state;
        let count = 0
        let score = 0
        if (questionTabelForm && questionTabelForm instanceof Array && questionTabelForm.length > 0) {
            count = questionTabelForm.length
            if (record['score']) {
                score = record['score'] * count
            }
        }
        let message = `共${count}题,共${score}分`
        return (
            <>

                <WizAlert message={message} type="info" showIcon />
                {this._renderStaticTable()}
            </>
        )
    }

    //右侧章节信息上部分
    _renderChapterInfo() {
        let { currentIndex, record } = this.state
        let rightInfo = null
        let titleModalForm = null
        if (!record['tabelType']) {
            record['tabelType'] = 'static'
        }
        let textInfo = '[' + this._getValue('chapter', record['type']) + '题目章节]'
        if (currentIndex !== -1) {
            if (record['type'] === 1) {
                titleModalForm = this._titleModalForm()
                rightInfo = this._renderStaticTable()
            } else if (record['type'] === 2) {
                titleModalForm = this._titleModalForm()
                rightInfo = this._renderDynamicTable()
            } else if (record['type'] === 0) {
                titleModalForm = this._titleModalForm()
                rightInfo = this._renderMultipleTable()
            } else {
                textInfo = ''
            }
        } else {
            textInfo = ''
        }

        return (
            <div className='chapter-info'>
                <div className='chapter-info-title'>
                    <WizTypography.Text className='title'>
                        {'章节信息'}
                        <WizTypography.Text className='contnet'>
                            {textInfo}
                        </WizTypography.Text>
                    </WizTypography.Text>
                </div>
                <div className='chapter-info-body'>
                    {titleModalForm}
                    {rightInfo}
                </div>
            </div>
        )
    }
    stepView = () => {
        const { data } = this.state
        let titleCount = 0
        let scoreCount = 0
        if (data && data instanceof Array && data.length > 0) {
            data.forEach((value, index) => {
                if (value['questionTabelForm'] && value['questionTabelForm'] instanceof Array) {
                    titleCount = titleCount + value['questionTabelForm'].length
                    let pattern = /^(([1-9][0-9]*)|(([0]\.\d{1,1}|[1-9][0-9]*\.\d{1,1})))$/

                    if (value['score'] && pattern.test(value['score'])) {
                        scoreCount = scoreCount + (value['questionTabelForm'].length * value['score'])
                    }
                }
                if (value['categoryTabelForm'] && value['categoryTabelForm'] instanceof Array) {
                    value['categoryTabelForm'].forEach((categoryTabel, key) => {
                        titleCount = titleCount + categoryTabel['total']
                        if (value['score']) {
                            scoreCount = scoreCount + (categoryTabel['total'] * value['score'])
                        }
                    })
                }
            })
        }
        return (
            <div className='look-chapter'>
                <div className='chapter-look-page'>
                    <WizRow>
                        <WizCol span={7} className='chapter-col'>
                            {this._renderChapterMenu()}
                        </WizCol>
                        <WizCol span={17}>
                            {this._renderChapterInfo()}
                        </WizCol>
                    </WizRow>
                </div>

                <div className="table-row">
                    <div className="outline-font">考试概要 </div>
                </div>
                <div className="div-outline">
                    {this.outlineView(data.length, '总章节数', { color: '#3D80E3' })}
                    <span className="separator" />
                    {this.outlineView(titleCount, '总题目数', { color: '#3DE3D5' })}
                    <span className="separator" />
                    {this.outlineView(scoreCount, '总分数', { color: '#E3773D' })}
                </div>
            </div>
        )
    }
    _render() {
        let { examLoading } = this.props
        return <Spin tip={'加载中'} spinning={examLoading}>
            {this.stepView()}
        </Spin>

    }
    fitterFieldsValue(data) {
    }
    /**概要内容 */
    outlineView(count, title, countColor) {
        return (
            <span className="outline-view">
                <div className="outline-count" style={countColor}>{count}</div>
                <div className="outline-title">{title}</div>
            </span>
        )
    }

}
const mapStateToProps = (state, ownProps) => {

    return {
    }
};

export default connect(mapStateToProps)(ChapterLook)
